type WriteBody = { status?: string; type?: string };

/**
 * The writes whose click-to-result time is recorded, keyed by `<method> <path>`.
 * A function names the action from the request body, because one endpoint
 * serves several actions. Add an entry to measure another write.
 */
export const WRITE_SPAN_NAMES: Record<
  string,
  string | ((body: WriteBody) => string)
> = {
  'post /statements': ({ status }) =>
    status === 'published' ? 'statement.publish' : 'statement.create',
  'put /statements/{id}': ({ status }) =>
    status === 'published' ? 'statement.publish' : 'statement.status-change',
  'post /statements/manager/pay': 'statement.pay',
  'post /transactions': ({ type }) => `${type ?? 'transaction'}.create`,
  'put /transactions/{id}': ({ type }) => `${type ?? 'transaction'}.update`,
  'post /reservations': 'reservation.create',
  'put /reservations/{id}': 'reservation.update',
  'post /listings': 'listing.create',
  'put /listings/{id}': 'listing.update',
  'post /reservations/journal-entries': 'reservation.journal-refresh',
  'post /transactions/journal-entries': 'transaction.journal-refresh',
};
